import efocats_validate_core from '../../../core/v1/validate/efocats_validate_core.js';
import EFOcats_error_info from '../../../core/v1/efocats_error_info.js';
import EFOcats_import_lang from '../../../core/v1/import/efocats_import_lang.js';

/**
 * 制限文字チェッククラス
 */
export default class EFOcats_validate_char extends efocats_validate_core {
  /**
   * コンストラクタ
   * @param patterns チェックパターンの配列 配列の要素は連想配列でpattern：正規表現 errid：エラーメッセージのID
   */
  constructor() {
    super();
    this.patterns = [];
  }

  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    this.patterns.forEach(element => {
      const match = this.errorMessage(checkData, element);

      if (match != null) {
        result = new EFOcats_error_info('error', match, '', match);
      }
    });

    return result;
  }

  /**
   * エラーメッセージ
   */
  errorMessage(checkData, element) {
    const arr = checkData.val().match(element.pattern);

    if (arr == null) {
      return null;
    }

    // 重複除去
    const dpset = new Set(arr);
    const dparr = Array.from(dpset);

    // 文字列化
    const match = dparr.join(' ');

    return EFOcats_import_lang.getValue(element.errid, {match});
  }
}
